import React, { useContext, useEffect } from "react";
import { FlashMessageContext, } from "../Context/FlashMessageContext";
import HighlightedContent from "../atoms/HighlightedContent";
let timer = null;
const FlashMessage = ({ className }) => {
    const { flashMessage, setFlashMessage } = useContext(FlashMessageContext);
    useEffect(() => {
        if (!flashMessage) {
            return;
        }
        if (timer) {
            window.clearTimeout(timer);
        }
        timer = setTimeout(() => {
            setFlashMessage(null);
        }, 3000);
    }, [flashMessage]);
    if (!flashMessage) {
        return null;
    }
    return React.createElement(HighlightedContent, null, flashMessage.message);
};
export default FlashMessage;
